// eslint-disable-next-line no-unused-vars
import Vue from "vue";
import { CancelToken } from "axios";
import { LOGOUT, ADD_SNACKBAR } from "../store/action-types";

export default {
  install(Vue, { axiosInstance, store }) {
    axiosInstance.interceptors.request.use(
      function(config) {
        // Do something before request is sent
        const now = new Date();

        if (
          store.state.auth.tokenExpirationDate &&
          now.getTime() >= store.state.auth.tokenExpirationDate
        ) {
          store.dispatch(`auth/${LOGOUT}`);
          store.dispatch(
            `app/${ADD_SNACKBAR}`,
            {
              message: "Votre session a expiré. Veuillez vous reconnecter.",
              type: "info"
            },
            { root: true }
          );

          return {
            ...config,
            cancelToken: new CancelToken(cancel =>
              cancel("Cancel repeated request")
            )
          };
        }

        return config;
      },
      function(error) {
        // Do something with request error
        return Promise.reject(error);
      }
    );

    axiosInstance.interceptors.response.use(
      res => res,
      error => {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        // const now = new Date();

        if (
          error.response &&
          error.response.status == "401"
          // now.getTime() >= store.state.auth.tokenExpirationDate.getTime()
        ) {
          store.dispatch(`auth/${LOGOUT}`);
        }
        return Promise.reject(error);
      }
    );
  }
};
